const METHODS = [
  {
    icon: "ri-archive-drawer-line",
    tag: "适合整册收藏",
    title: "打包下载",
    desc: "把整本或整批资源压缩成一个包，一次点选即可拿到完整合集。适合想要整册收藏、不喜欢一本一本慢慢存的用户。",
    points: ["支持整册/整系列一次取用", "文件结构完整不乱", "适合二次整理与归档"],
    color: "primary",
  },
  {
    icon: "ri-stack-line",
    tag: "适合多资源搬运",
    title: "批量下载",
    desc: "通过列表或队列批量获取，一次性把多本资源依次存入本地。适合需要大量搬运、成系列收集的场景。",
    points: ["可批量选中多本资源", "自动排队避免遗漏", "大幅节省逐个操作时间"],
    color: "accent",
  },
  {
    icon: "ri-cloud-off-line",
    tag: "适合长期保存",
    title: "离线下载",
    desc: "先把资源拉到云端或中转空间，再慢慢转到本地设备。适合网络不稳、想要断点续传或永久留档的用户。",
    points: ["不受网速波动影响", "支持断点续传", "本地空间更自由"],
    color: "secondary",
  },
];

export default function Methods() {
  return (
    <section id="methods" className="relative w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600">
            <i className="ri-vip-crown-2-line"></i>
            下载方式概览
          </span>
          <h2 className="font-display text-2xl md:text-4xl text-foreground-950 mt-3">
            三种主流下载方式，按需选择
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            不同场景对应不同解法。先弄清楚打包、批量、离线各自适合什么，再下手操作，能少走很多弯路。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {METHODS.map((m) => (
            <article
              key={m.title}
              className={`group relative rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7 transition-transform duration-300 hover:-translate-y-1.5 ${
                m.color === "primary"
                  ? "bg-primary-50/70 border-primary-200"
                  : m.color === "accent"
                  ? "bg-accent-50/70 border-accent-200"
                  : "bg-secondary-50/70 border-secondary-200"
              }`}
            >
              <div className="flex items-start justify-between">
                <span
                  className={`w-12 h-12 flex items-center justify-center rounded-xl text-background-50 ${
                    m.color === "primary"
                      ? "bg-primary-500"
                      : m.color === "accent"
                      ? "bg-accent-500"
                      : "bg-secondary-500"
                  }`}
                >
                  <i className={`${m.icon} text-xl`}></i>
                </span>
                <span
                  className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                    m.color === "primary"
                      ? "bg-primary-100 text-primary-700"
                      : m.color === "accent"
                      ? "bg-accent-100 text-accent-700"
                      : "bg-secondary-100 text-secondary-700"
                  }`}
                >
                  {m.tag}
                </span>
              </div>

              <h3 className="font-display text-xl text-foreground-950 mt-5">{m.title}</h3>
              <p className="mt-2.5 text-sm text-foreground-700 leading-relaxed">{m.desc}</p>

              <ul className="mt-5 space-y-2">
                {m.points.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm text-foreground-800">
                    <i
                      className={`mt-0.5 ${
                        m.color === "primary"
                          ? "text-primary-600"
                          : m.color === "accent"
                          ? "text-accent-600"
                          : "text-secondary-600"
                      } ri-checkbox-circle-line`}
                    ></i>
                    {p}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <p className="mt-8 text-sm text-foreground-500 leading-relaxed">
          提示：三种方式并非互斥。实际操作中，常先用<span className="text-primary-700 font-semibold">批量下载</span>把资源抓到云端，
          再用<span className="text-accent-700 font-semibold">离线下载</span>慢慢转存，最后用<span className="text-secondary-700 font-semibold">打包下载</span>整理归档，组合使用效果更佳。
        </p>
      </div>
    </section>
  );
}